import { render, staticRenderFns } from "./bindPersonDetail.vue?vue&type=template&id=7a0ca27e&scoped=true&"
import script from "./bindPersonDetail.vue?vue&type=script&lang=js&"
export * from "./bindPersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./bindPersonDetail.vue?vue&type=style&index=0&id=7a0ca27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0ca27e",
  null
  
)

export default component.exports